import { h, Component } from 'preact';
import { AuthService } from '../../services/auth.service';
import { route, getCurrentUrl } from 'preact-router';
import { IGuardedRouteProps } from './IGuardedRoute';
import { ModalDialog } from '../modalDialog/modalDialog';
import { BuildingApiService } from '../../services/buildingapi.service';
import { UserTypeEnum } from '../../enums/UserTypeEnum';

export class GuardedRoute extends Component<any, any> {

    public auth: AuthService;
    public modal: ModalDialog;
    public buildingService: BuildingApiService;

    constructor(props, ctx) {
        super(props, ctx);
        this.auth = ctx.auth;
        this.modal = ctx.modal;
        this.buildingService = ctx.buildingService;
        this.state = {
            blocked: true
        };
    }

    componentWillMount() {
        if (this.props.isSignIn) {
            this.modal.showLoader(this.buildingService.getSigninOptions(this.props.buildingId))
                .then((r) => {
                    console.log(r);
                    if (r.errorMessage) {
                        this.modal.alert(r.errorMessage);
                        return;
                    }
                    localStorage.setItem("buildingOptions", JSON.stringify(r.result));
                    if (!this.auth.isAuthenticated()) {                        
                        localStorage.setItem("returnUrl", getCurrentUrl());
                        route('/register-with-options', true);
                    } else {
                        var userType = this.auth.getUserType();
                        if ((userType == UserTypeEnum.Contractor && !r.result.allowContractors) ||
                            (userType == UserTypeEnum.Tenant && !r.result.allowTenants) ||
                            (userType == UserTypeEnum.Visitor && !r.result.allowVisitors)) {
                            this.modal.alert(`Sorry, ${UserTypeEnum.getTextValue(userType)}s are not enabled for Sign-in at ${r.result.buildingName}.   If you are a different type of user, please click on the dots in the top right, forget your details, and register again`);
                        }
                        else {
                            this.setState({ blocked: false });
                        }
                    }
                });
            return;
        }

        this.setState({ blocked: false });

        if (!this.auth.isAuthenticated()) {
            localStorage.setItem("returnUrl", getCurrentUrl());
            route('/register', true);
        }
    }

    render(el?: any) {

        if (!this.auth.isAuthenticated() || this.state.blocked)
            return <div></div>;
        if (!this.auth.hasAnyRoles(this.props.roles)) {
            localStorage.setItem("returnUrl", '');
            route('/register', true);
        }
        if (this.props.component)
            return h(this.props.component, this.props);
        return <div>{this.props.children}</div>;
    }
}



// WEBPACK FOOTER //
// ./components/guardedRoute/guardedRoute.tsx